import { actionCategories } from '@/store/model/sport/football/ActionCategories'

export default class Action {
  constructor (dataAction, match) {
    this.id = dataAction.id
    this.matchId = dataAction.matchId
    this.match = match
    this.typeId = dataAction.typeId
    this.teamId = dataAction.teamId
    this.team2Id = dataAction.team2Id
    this.personId = dataAction.personId
    this.person2Id = dataAction.person2Id
    this.statusId = dataAction.statusId
    this.originId = dataAction.originId
    this.destinationId = dataAction.destinationId
    this.detail1Id = dataAction.detail1Id
    this.detail2Id = dataAction.detail2Id
    this.qualityId = dataAction.qualityId
    this.minute = dataAction.minute
    this.owngoal = dataAction.owngoal
    this.goal = dataAction.goal
    this.chance = dataAction.chance
    this.saved = dataAction.saved
    this.canceled = dataAction.canceled
    this.active = dataAction.active
    this.date = dataAction.date ? new Date(dataAction.date) : null

    this.homeAway = this.teamId === this.match.teamHomeId ? 'home' : (this.teamId === this.match.teamAwayId ? 'away' : '')
    this.awayHome = this.teamId === this.match.teamHomeId ? 'away' : (this.teamId === this.match.teamAwayId ? 'home' : '')

    this.open = false

    this.category = actionCategories.searchByAction(this)
  }
}
